export default __webpack_public_path__ + "media/assets/img/checkbox-check-9d215293b5cd806b2e0c96a7b18c69d1.svg";